<template>
      <div no-body> 
      <b-row v-if="lkuLoading" class="justify-content-center mb-2"><span style="color:blue;">Loading data ...</span></b-row>
      <b-row v-else>
        <b-col lg="8">
          <b-form-group label-cols=3 label="Filter User">
              <b-row>
                <b-col class="pl-1 pr-1" cols="7"><b-form-input v-model="tblData.full_name" @keyup.13.native="refresh()" placeholder="Full Name"></b-form-input></b-col>
                <b-col class="pl-1 pr-1" cols="5"><b-form-input v-model="tblData.username" @keyup.13.native="refresh()" placeholder="User Name"></b-form-input></b-col>
              </b-row>                      
          </b-form-group>
        </b-col>
      </b-row>
        <b-table
          class="mb-0"
          ref="tblVendor"
          responsive
          striped hover small 
          style="font-size:smaller;" 
          :items="data"
          :fields="fields"
          :current-page="tblData.page"
          :per-page="tblData.limit"
          :sort-by.sync="tblData.sortBy"
          :sort-desc.sync="tblData.sortDesc"
          :key="tblData.limit" 
          @row-clicked="selectItem"
        >
          <template v-slot:cell(alamat)="data">
            {{data.item.alamat}} {{data.item.kota}} {{data.item.negara}}
          </template>
        </b-table>
      <b-row>
        <b-col cols="4">
          <div class="pt-2">
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
        </div>        
        </b-col>
        <b-col cols="3">            
            <b-row class="ml-2 mt-2">
              <span class="pt-1 pr-2">Limit per page</span>
              <b-form-select :options="[10, 15, 20, 25]" :plain="true" v-model="tblData.limit"  size="sm" style="width:80px !important;"/>
            </b-row>
        </b-col>
        <b-col cols="5">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
      </div>
</template>

<script>
import auth from "../../apis/auth";

export default {
  data() {
    return {
      fields: [
          {
            key: "username",
            label: "User name",
            thStyle: "width:130px",
            sortable: true
          },
          {
            key: "full_name",
            label: "Full Name",
            sortable: true
          },
          {
            key: "company",
            label: "Company Name",
            sortable: true
          },
          {
            key: "jabatan",
            label: "Job Title",
            sortable: true
          },
          
      ],
      tblData: {
        page: 1,
        limit: 10,
        total: 0,
        sortBy: null,
        sortDesc: false,
      },
      lkuLoading:false
    };
  },
  computed: {
    filterKode() {
      return this.tblData.username;
    },
    filterNamaAcc() {
      return this.tblData.full_name;
    },
  },
  watch: {
    filterKode: function(kode) {
      setTimeout(() => {
        if (kode == this.tblData.username) this.refresh();
      }, 500);
    },    
    filterNamaAcc: function(full_name) {
      setTimeout(() => {
        if (full_name == this.tblData.full_name) this.refresh();
      }, 500);
    },    
  },
  methods: {
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
    },
    data: async function(ctx) {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      this.lkuLoading = true;
      let list = await auth.users(this.tblData);
      this.lkuLoading = false;
      return list;  
    },
    selectItem(item,index) {
      // 'item' will be the row data from items
      // `index` will be the visible row number (available in the v-model 'shownItems')
      this.$emit("click", item);
    },
    refresh() {
      this.$refs.tblVendor.refresh();
    }
  }
};
</script>
